var IS_TOUCH_DEVICE = 'ontouchstart' in window;
export var DRAG_START_EVENT_NAME = IS_TOUCH_DEVICE ? 'touchstart' : 'mousedown';
export var DRAG_END_EVENT_NAME = IS_TOUCH_DEVICE ? 'touchend' : 'mouseup';
export var DRAG_MOVE_EVENT_NAME = IS_TOUCH_DEVICE ? 'touchmove' : 'mousemove';
export var initDrag = function (start, end, move, el) {
    el = el || window;
    el.addEventListener(DRAG_START_EVENT_NAME, start, { passive: false });
    el.addEventListener(DRAG_END_EVENT_NAME, end);
    el.addEventListener(DRAG_MOVE_EVENT_NAME, move, { passive: false });
};
export var disableDrag = function (start, end, move, el) {
    el = el || window;
    el.removeEventListener(DRAG_START_EVENT_NAME, start);
    el.removeEventListener(DRAG_END_EVENT_NAME, end);
    el.removeEventListener(DRAG_MOVE_EVENT_NAME, move);
};
/*
componentDidMount(): void {
  initDrag(this.mousedown, this.mouseup, this.mousemove);
}

componentWillUnmount(): void {
  disableDrag(this.mousedown, this.mouseup, this.mousemove);
}

private mousedown = (e: MouseEvent | TouchEvent) => {
  //...
};

private mouseup = (e: MouseEvent | TouchEvent) => {
  //...
};

private mousemove = (e: MouseEvent | TouchEvent) => {
  //...
};
*/
